module.exports = __webpack_public_path__ + "static/scenes-solutions-2-a91f01cbca5336acd02cd27d28dcd580.png";